<template>
  <!--
      作者 gmshop
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">商城设置</div>
      <el-form-item label="商城名称" :rules="[{required: true,message: ' '}]" prop="name">
        <el-input v-model="form.name" placeholder="商城名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="展示销量">
        <el-radio v-model="form.show_sales" :label="0">关闭</el-radio>
        <el-radio v-model="form.show_sales" :label="10">开启</el-radio>
      </el-form-item>
      <el-form-item label="展示浏览量" >
        <el-radio v-model="form.show_views" :label="0">关闭</el-radio>
        <el-radio v-model="form.show_views" :label="10">开启</el-radio>
      </el-form-item>
      <el-form-item label="首页登陆提示">
        <el-radio v-model="form.is_wxlogin" :label="10">开启</el-radio>
        <el-radio v-model="form.is_wxlogin" :label="0">关闭</el-radio>
      </el-form-item>
      <el-form-item label="用户中心订单图标/文字">
        <div>
          <p>文字颜色</p>
            <el-color-picker v-model="form.order.color"></el-color-picker>
        </div>

        <div class="d-s-c">
          <div>
            <el-button @click="chooseImg(3)">选择图片</el-button>
            <img class="mt10" v-img-url="form.order.icon1" width="100">
            <div :style="'color:'+form.order.color">待付款</div>
          </div>
          <div>
            <el-button @click="chooseImg(4)">选择图片</el-button>
            <img class="mt10" v-img-url="form.order.icon2" width="100">
            <div :style="'color:'+form.order.color">待发货</div>
          </div>
          <div>
            <el-button @click="chooseImg(5)">选择图片</el-button>
            <img class="mt10" v-img-url="form.order.icon3" width="100">
            <div :style="'color:'+form.order.color">待收货</div>
          </div>
          <div>
            <el-button @click="chooseImg(6)">选择图片</el-button>
            <img class="mt10" v-img-url="form.order.icon4" width="100">
            <div :style="'color:'+form.order.color">待评价</div>
          </div>
          <div>
            <el-button @click="chooseImg(7)">选择图片</el-button>
            <img class="mt10" v-img-url="form.order.icon5" width="100">
            <div :style="'color:'+form.order.color">退款/售后</div>
          </div>

        </div>
        <div>图片尺寸：60x60
          <el-button @click="clearIcon()">清除所有图片</el-button>
        </div>
      </el-form-item>
      <el-form-item label="小程序登陆页logo" v-auth="'/appsetting/appwx/index'">
        <el-button @click="chooseImg(2)">选择图片</el-button>
        <img class="mt10" v-img-url="form.login_logo" width="100">
      </el-form-item>
      <div class="common-form" v-auth="'/supplier'">供应商设置</div>
      <el-form-item v-auth="'/supplier'" label="资格开通费用 " prop="supplier_price">
        <el-input type="number" v-model="form.supplier_price" placeholder="供应商资格开通费用" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item v-auth="'/supplier'" label="供应商申请图片" >
        <el-button @click="chooseImg(1)">选择图片</el-button>
        <img class="mt10" v-img-url="form.supplier_image" width="200">
      </el-form-item>
      <el-form-item v-auth="'/supplier'" label="供应商申请协议 ">
        <el-input v-model="form.supplier_license" type="textarea" rows="5" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">日志记录</div>
      <el-form-item label="是否记录查询日志" prop="customer">
        <el-checkbox v-model="form.is_get_log">是否记录查询日志</el-checkbox>
        <div class="tips">如果记录，日志量会有点大</div>
      </el-form-item>
      <div class="common-form">商城下单记录轮播</div>
      <el-form-item label="是否显示下单轮播">
        <el-checkbox v-model="form.is_order_record">是否显示下单轮播</el-checkbox>
      </el-form-item>
      <div class="common-form">物流查询api</div>
      <el-form-item label="快递查询平台">
       <div>
         <el-radio v-model="form.delivery_platform" :label="20">快递助手</el-radio>
         <el-radio v-model="form.delivery_platform" :label="0">快递100</el-radio>

         <el-radio v-model="form.delivery_platform" :label="10">快递鸟</el-radio>

       </div>
      </el-form-item>
      <div v-if="form.delivery_platform==0">
        <el-form-item label="快递100 Customer" :rules="[{required: true,message: ' '}]" prop="customer">
          <el-input v-model="form.customer" placeholder="" class="max-w460"></el-input>
          <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://www.kuaidi100.com/openapi/" target="_blank"
              type="primary">快递100申请</el-link>
          </div>
        </el-form-item>
        <el-form-item label="快递100 Key" :rules="[{required: true,message: ' '}]" prop="key">
          <el-input v-model="form.key" placeholder="" class="max-w460"></el-input>
        </el-form-item>
      </div>
      <div  v-if="form.delivery_platform==10">
          <el-form-item label="接口类型">
          <div>
            <el-radio v-model="form.api_type" :label="1002">免费版</el-radio>

            <el-radio v-model="form.api_type" :label="8001">付费版</el-radio>
            <div class="tips">
              免费版（仅支持圆通、申通、百世、天天）的查询（每天限量100）
            </div>
          </div>
          </el-form-item>
          <el-form-item label="快递鸟 ID" :rules="[{required: true,message: ' '}]" prop="id">
            <el-input v-model="form.id" placeholder="" class="max-w460"></el-input>
            <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://www.kdniao.com" target="_blank"
                type="primary">快递鸟申请</el-link>
            </div>
          </el-form-item>
          <el-form-item label="快递鸟 apiKey" :rules="[{required: true,message: ' '}]" prop="apiKey">
            <el-input v-model="form.apiKey" placeholder="" class="max-w460"></el-input>
          </el-form-item>
      </div>
      <div v-if="form.delivery_platform==20">
        <el-form-item label="快递助手key"  prop="kdzs_key">
          <el-input v-model="form.kdzs_key" placeholder="" class="max-w460"></el-input>

        </el-form-item>
        <el-form-item label="快递助手secret"  prop="kdzs_secret">
          <el-input v-model="form.kdzs_secret" placeholder="" class="max-w460"></el-input>
          <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://consoleopen.kdzs.com" target="_blank"
              type="primary">快递助手申请</el-link>
          </div>
        </el-form-item>
      </div>
      <div class="common-form">用户协议设置</div>
      <!-- <el-form-item label="下单需要同意协议">
        <el-radio v-model="form.is_agree" :label="10">开启</el-radio>
        <el-radio v-model="form.is_agree" :label="20">关闭</el-radio>
      </el-form-item> -->
      <el-form-item label="协议内容" v-if="!loading">
        <div class="edit_container">
          <Uediter v-model="form.agree_content" id="ue" :text="form.agree_content" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>



      <div class="common-form">充值卡协议设置</div>
      <el-form-item label="充值卡协议" v-if="!loading">
        <div class="edit_container">
          <Uediter v-model="form.agreepg_content" id="uepg" :text="form.agreepg_content" :config="ueditor.config" ref="uepg"></Uediter>
        </div>
      </el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
<!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset"  @closeDialog="closeLinkset" >选择链接</Setlink>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import Uediter from '@/components/UE.vue';
  import Setlink from "@/components/setlink/Setlink";
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{
      Setlink,
      Upload,
      Uediter
    },
    data() {
      return {
        imgType:0,
        is_linkset:false,
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          page:'',
          name: '',
          customer: '',
          key: '',
          id: '',
          apiKey: '',
          kdzs_key:'',
          kdzs_secret:'',
          is_get_log: 0,
          delivery_platform: 20,
          api_type: 0,
          is_order_record: 0,
          is_wxlogin:0,
          show_sales:10,
          show_views:0,
          is_agree: 10,
          agree_content: '',
          agreepg_content: '',
          order:{
              icon1:'',
              icon2:'',
              icon3:'',
              icon4:'',
              icon5:'',
              color: '#000000'
          }
        },
        delivery_type: [],
        /*是否打开图片选择*/
        isupload:false,
        /*富文本配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        }
      };
    },
    created() {
      this.getParams()
    },

    methods: {
       /*选择链接*/
      changeLink() {
        this.is_linkset = true;
      },
      clearLink() {
        this.form.page = {};
      },

      /*获取链接并关闭弹窗*/
      closeLinkset(e) {
        this.is_linkset = false;
        if (e) {
          this.form.page.linkUrl = e.url;
          this.form.page.name = "链接到" + " " + e.type + " " + e.name;
          this.form.page.url_type =  e.url_type?e.url_type:'';
          if(e.appid) this.form.page.appid =  e.appid;
        }
      },
      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.storeDetail({}, true).then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);

            self.form.customer = vars.kuaidi100.customer;
            self.form.page = vars.page?vars.page:{};
            self.form.key = vars.kuaidi100.key;
            self.form.id = vars.kdniao.id;
            self.form.apiKey = vars.kdniao.apiKey;
            self.form.api_type = vars.kdniao.api_type;
            self.form.kdzs_key = vars.kdzs.key;
            self.form.kdzs_secret = vars.kdzs.secret;
            self.form.delivery_platform = vars.delivery_platform;
            self.form.is_agree = vars.is_agree || self.form.is_agree;
            self.form.is_wxlogin = vars.is_wxlogin || self.form.is_wxlogin;
            self.form.show_views = vars.show_views || self.form.show_views;
            self.form.show_sales = vars.show_sales || self.form.show_sales;
            self.form.agree_content = vars.agree_content || self.form.agree_content;
            self.form.agreepg_content = vars.agreepg_content || self.form.agreepg_content;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        if (self.form.is_agree == 10) {
          params.agree_content = this.$refs.ue.getUEContent();
        }
        params.agreepg_content = this.$refs.uepg.getUEContent();

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editStore(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，商城设置成功',
                  type: 'success'
                });
                self.$router.push('/setting/store/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },

      /*选择图片*/
      chooseImg(imgType){
        this.imgType = imgType;
        this.isupload=true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        if(this.imgType==1){
            this.form.supplier_image=e[0].file_path;
        }
        if(this.imgType==2){
            this.form.login_logo=e[0].file_path;
        }
        if(this.imgType==3){
            this.form.order.icon1=e[0].file_path;
        }
        if(this.imgType==4){
            this.form.order.icon2=e[0].file_path;
        }
        if(this.imgType==5){
            this.form.order.icon3=e[0].file_path;
        }
        if(this.imgType==6){
            this.form.order.icon4=e[0].file_path;
        }
        if(this.imgType==7){
            this.form.order.icon5=e[0].file_path;
        }

      },
      clearIcon(){
        this.form.order.icon1 = '';
        this.form.order.icon2 = '';
        this.form.order.icon3 = '';
        this.form.order.icon4 = '';
        this.form.order.icon5 = '';
      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue